import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Routes from "./components/Routes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

// Styles
import "bootstrap/dist/css/bootstrap.css";
import "./styles/global.css";
import { de } from "date-fns/locale";

const root = createRoot(document.getElementById("app")!);

const muiTheme = createTheme({
  components: {
    MuiStepIcon: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            color: "rgb(0, 155, 229) !important",
          },
        },
      },
    },
  },
  palette: {
    common: {
      white: "#fff", // това е ок, но ако липсва напълно, няма да работи
    },
  },
});

root.render(
  <ThemeProvider theme={muiTheme}>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </LocalizationProvider>
  </ThemeProvider>
);

// Allow Hot Module Reloading
declare var module: any;
if (module.hot) {
  module.hot.accept();
}
